import { Card, Empty } from 'antd';

import FunnelBarWithPercentageComparison from '../../components/ManagerDashboard/FunnelBarWithPercentageComparison';
import { RecruitmentProcessCollection, StageCollection } from '../../types';

interface ConversionFunnelProps {
  totalVacancyPositions: number;
  totalCandidates?: number;
  stages?: StageCollection[];
  dashboardStatus?: RecruitmentProcessCollection['status'];
  subscribedCount?: number;
  recruitmentProcessesCountByStage?: number[];
  statusRecruitmentProcessesCountByStage?: number[];
}

const ConversionFunnel = ({
  totalVacancyPositions,
  totalCandidates,
  stages,
  dashboardStatus,
  subscribedCount,
  recruitmentProcessesCountByStage,
  statusRecruitmentProcessesCountByStage,
}: ConversionFunnelProps) => {
  return (
    <Card>
      {totalCandidates === subscribedCount ? (
        <Empty description="Não há dados suficientes ainda para avaliar conversão" />
      ) : (
        <>
          {stages?.map((stage, idx) => {
            return (
              <FunnelBarWithPercentageComparison
                key={stage.id}
                totalVacancyPositions={totalVacancyPositions}
                stageName={stage.name}
                totalCandidates={totalCandidates || 1}
                previousStageCounter={recruitmentProcessesCountByStage?.[idx - 1] ?? 0}
                accumulatedCounter={
                  recruitmentProcessesCountByStage
                    ?.slice(idx)
                    .reduce((acc, curr) => acc + curr, 0) ?? 0
                }
                currentStageCounter={statusRecruitmentProcessesCountByStage?.[idx] ?? 0}
                dashboardStatus={dashboardStatus}
              />
            );
          })}
        </>
      )}
    </Card>
  );
};

export default ConversionFunnel;
